import { fetchUsersFail, fetchUsersSuccess } from './actions';
import { put } from 'redux-saga/effects';
import { getUsers } from '../user.backend';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';

export function* fetchUsersSaga() {
    try {
        const response = yield getUsers();
        yield put(fetchUsersSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchUsersFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
